import React from "react";
import MultipleChoiceQuestion from "./types/MultipleChoiceQuestion";
import TrueFalseQuestion from "./types/TrueFalseQuestion";
import MatchingQuestion from "./types/MatchingQuestion";
import ImageQuestion from "./types/ImageQuestion";
import AudioQuestion from "./types/AudioQuestion";
import VideoQuestion from "./types/VideoQuestion";
import TextQuestion from "./types/TextQuestion";

const QuestionContent = ({ question, answer, onAnswer }) => {
  if (!question) return <p className="text-gray-500">سوالی وجود ندارد.</p>;

  switch (question.type) {
    case "multiple_choice":
      return (
        <MultipleChoiceQuestion
          question={question}
          answer={answer}
          onAnswer={onAnswer}
        />
      );

    case "true_false":
      return (
        <TrueFalseQuestion
          question={question}
          answer={answer}
          onAnswer={onAnswer}
        />
      );

    case "matching":
      return (
        <MatchingQuestion
          question={question}
          answer={answer}
          onAnswer={onAnswer}
        />
      );

    case "image":
      return (
        <ImageQuestion
          question={question}
          answer={answer}
          onAnswer={onAnswer}
        />
      );

    case "audio":
      return (
        <AudioQuestion
          question={question}
          answer={answer}
          onAnswer={onAnswer}
        />
      );

    case "video":
      return (
        <VideoQuestion
          question={question}
          answer={answer}
          onAnswer={onAnswer}
        />
      );

    case "text":
      return (
        <TextQuestion
          question={question}
          answer={answer}
          onAnswer={onAnswer}
        />
      );

    default:
      return (
        <div className="text-sm text-red-600">
          نوع سوال پشتیبانی نمی‌شود.
        </div>
      );
  }
};

export default QuestionContent;
